/* eslint-disable no-console */
import React, { useState, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  DashboardLayout,
  OverlayDashboard,
  DownloadButtonWrapper,
} from "./styles";
import Waiting from "../Waiting";
import {
  setSelectedYear,
} from "../../redux/actions";
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";
import YearDropdownNew from "../common/YearDropdown/YearDropdownNew";
import { TabContainerV1, TabViewV1 } from "../ChallengeDetailsV2/styles";
import { Container } from "../ChallengeDashboardV2/CompletedChallenge/styles";
import Overview from "./overview";
import { AddCoachEventsIcon, AdminDownloadIcon, DropIcon, WellnessAddIconBranding } from "../../utils/icons";
import { toast } from "react-toastify";
import { Dropdown } from "react-bootstrap";
import { EventEngagementData, GetPastEvents, DownloadOnDemandEventCSV } from "../../redux/constants/apiConstants";
import { fetchApi, getPermissionStatus } from "../../utils/methods";
import CompletedEvent from "./completedEvent";
import HoverButton from "../common/HoverButton";
import CSVList from '../AttendeesModal/CSVList';
import EventLibrary from "./eventLibrary";
import CoachDirectory from "./EventLibrary/CoachDirectory";

// ThemedEvents component using CompletedEvent with filtered themed events
const ThemedEvents = ({ themedEvents, history, isAdmin, showLoadPast, loadMoreEvents, totalCount }) =>  (
  <div>
    <CompletedEvent
      pastEvents={themedEvents}
      history={history}
      loadMoreEvents={loadMoreEvents}
      totalCount={totalCount}
      role={isAdmin ? "ADMIN" : "USER"}
      isAdmin={isAdmin}
      fetchPastEvents={() => {}} // Empty function since we're using loadMoreEvents
      showLoadPast={showLoadPast}
    />
  </div>
);

ThemedEvents.propTypes = {
  themedEvents: PropTypes.array,
  history: PropTypes.object,
  isAdmin: PropTypes.bool,
  showLoadPast: PropTypes.bool,
  loadMoreEvents: PropTypes.func,
  totalCount: PropTypes.number,
};

const CompanyEvents = (props) => {
  const {
    networkError,
    history,
    yearList,
    selectedYearInfo,
    user,
    companyInfo,
    setSelectedYear,
    role,
    userPermissions,
    brandingColor,
    allRoles

  } = props;

  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const dropdownRef = useRef();
  const [EngagementDataLoading,setEngagementDataLoading]=useState([]);
  const [EngagementData,setEngagementData]=useState([]);
  const [selectedTabId, setselectedTabId] = useState(1);
  const [completedSubTab, setCompletedSubTab] = useState("events"); // "events" or "themed"
  const [pastEvents, setpastEvents] = useState([]);
  const [themedEvents, setThemedEvents] = useState([]);
  const [totalCount, settotalCount] = useState(1);
  const [PageNumber,setPageNumber] = useState(1);
  const [ondemandList, setOndemandList] = useState([]);
  const[printCSV,setPrintCSV]=useState(false);
  const [showLoadPast, checkPastevent]=useState(true);
  const isWellnessAdmin = allRoles?.some((role) => role.rid === 12);
  const isSuperAdmin = allRoles?.some((role) => role.rid === 3);
  const isCelebrationEvent =true

  const CsvHeaders = [
    { label: "Event Name", key: "EVENTNAME" },
    { label: "Coach Name", key: "COACHNAME" },
    { label: "Video Url", key: "video_url"},
    { label: "Event ID", key: "EVENTID" },
    { label: "Event Tag", key: "EVENTTAG"},
    { label: "Last Updated", key: "Last Updated"},
  ];

  const printAction = () => {
    let data = [];
    ondemandList && ondemandList?.length > 0 && ondemandList.map((best) => {
      let obj = {};
      obj['EVENTNAME'] = best['event_name'];
      obj['COACHNAME'] = best['coach_name'];
      obj['EVENTID'] = best['event_id'];
      obj['EVENTTAG']=best['event_tag']
      obj['video_url']=best['video_url']
      obj['Last Updated']=best['Last Updated']
      data.push(obj);
    });
    return data;
  };


  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(()=>{
    GetEventsEngagement(companyInfo?.id,selectedYearInfo);
    GetCompletedEvents(PageNumber,50,companyInfo?.id,selectedYearInfo);
    FetchOndemandList()
    if(history.location.pathname === "/company/events"){
      setselectedTabId(1)
    }else if(history.location.pathname === "/company/events/completed"){
      setselectedTabId(2)
    }else if(history.location.pathname === "/company/events/library"){
      setselectedTabId(3)
    }else if(history.location.pathname === "/company/events/coach-directory"){
      setselectedTabId(4)
    }
  },[])

  const GetEventsEngagement = async(companyId, year)=>{
    setEngagementDataLoading(true);
    const apiUrl = EventEngagementData + "/" + companyId + "/" + year;
    try{
      const res = await fetchApi(apiUrl,"GET");
      if(res.status === "success"){
        setEngagementDataLoading(false);
        setEngagementData(res?.data);
      }else{
        toast.error(res.error)
        setEngagementDataLoading(false);

      }
    }catch(error){
      window.console.error(error);
    }
  }

  const FetchOndemandList = async()=>{
    const apiUrl = DownloadOnDemandEventCSV ;
    try{
      const res = await fetchApi(apiUrl,"GET");
      if(res.status === "success"){
        setOndemandList(res?.data[0]);
      }else{
        toast.error(res.error)
      }
    }catch(error){
      window.console.error(error);
    }
  }

  const memoizedOverviewProps = useMemo(() => ({
    history,
    user,
    EngagementData: EngagementData,
    EngagementDataLoading: EngagementDataLoading,
    companyId: companyInfo?.id,
    role,
    selectedYear:selectedYearInfo,
    GetEventsEngagement
  }), [history, user, EngagementData, EngagementDataLoading, companyInfo?.id,role,selectedYearInfo]);

  const MemoizedOverview = useMemo(() => React.memo(Overview), []);

  const GetCompletedEvents = async(pageNumber,limit,companyId, year)=>{
    const apiUrl =  `${GetPastEvents}/${pageNumber}/${limit}/${companyId}/${year}` 
    try{
      const res = await fetchApi(apiUrl,"GET");
      if(res.status === "success"){
        const allEvents = res.data.response || [];
        
        // Separate themed events from regular events
        const themedEventsList = allEvents.filter((event) => event.event_type === "theme");
        const regularEventsList = allEvents.filter((event) => event.event_type !== "theme");
        
        setpastEvents([...pastEvents,...regularEventsList]);
        setThemedEvents([...themedEvents,...themedEventsList]);
        settotalCount(res?.data?.count || 1000);
        setPageNumber(pageNumber)
        checkPastevent(false)
      }else{
        toast.error(res.error)
      }
    }catch(error){
      window.console.error(error);
    }
  }

  const handleClickOutside = (event) => {
    if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
      setMenuIsOpen(false);
    }
  };

  const toggleMenu = () => {
    setMenuIsOpen((prevMenuIsOpen) => !prevMenuIsOpen);
  };

  const updateDropdown = (year) => {
    setSelectedYear(year);
    GetEventsEngagement(companyInfo?.id,year)
    GetCompletedEvents(PageNumber,50,companyInfo?.id,year);
  };

  const showPastEvents = (path) => {
    history.push(path);
  };

  if (networkError || isNull(user) || isUndefined(user)) {
    return <Waiting />;
  }

  const createEventPermission = getPermissionStatus(
    "Create event",
    userPermissions
  );

  const loadMorePastEvents = (pageNumber) => {
    GetCompletedEvents(pageNumber,50,companyInfo?.id,selectedYearInfo);
    setPageNumber(pageNumber)
  };

  const loadMoreThemedEvents = (pageNumber) => {
    // For themed events, we might want to load more themed events specifically
    GetCompletedEvents(pageNumber,50,companyInfo?.id,selectedYearInfo);
    setPageNumber(pageNumber)
  };

  const downloadEnrolledList = (bool) => {
    setPrintCSV(bool);
  };

  let getColor = brandingColor ? brandingColor : "#DA6C74"
  return (
    <Container>
      <div className="mainContainer">
        <OverlayDashboard>
          <DashboardLayout>
            {/* Main Tabs */}
            <TabContainerV1 marginBottom="20px">
              <TabViewV1
                background={getColor ? getColor : "#0b4170"}
                width
                padding
                active={selectedTabId === 1}
                onClick={() =>{showPastEvents("/company/events");setselectedTabId(1)}}
              >
                {"Snapshot"}
              </TabViewV1>
              <TabViewV1
                background={getColor ? getColor : "#0b4170"}
                width
                padding
                active={selectedTabId === 2}
                onClick={() =>
                {showPastEvents("/company/events/completed");setselectedTabId(2)}
                }
              >
                {" "}
                {"Completed"}
              </TabViewV1>
              <TabViewV1
                background={getColor ? getColor : "#0b4170"}
                width
                padding
                active={selectedTabId === 3}
                onClick={() =>{
                  showPastEvents("/company/events/library");setselectedTabId(3);
                }
                }
              >
                {" "}
                {"Library"}
              </TabViewV1>
              { isSuperAdmin ?  <TabViewV1
                background={getColor ? getColor : "#0b4170"}
                width
                padding
                active={selectedTabId === 4}
                onClick={() =>{showPastEvents("/company/events/coach-directory");setselectedTabId(4)}}
              >
                {"Coach Directory"}
              </TabViewV1> : null}


              {/* <div
                      onClick={() => history.push(`/company/events/create`)}
                      style={{ cursor: "pointer",margin:"8px 8px 0px 0px" }}
                    >
                      <HoverButton
                        width="24px"
                        height="24px"
                        marginLeft="16px"
                        svgPath={AddIconBranding(24, 24)}
                        activeColor="#DA6C74"
                        fillOpacity={1}
                        inActiveColor="#DA6C74"
                        backgroundColor="rgba(254, 254, 254, 0.60)"
                        backgroundColorActive="#DA6C74"
                        title="Create Events"
                      />
                    </div> */}
              
              <DownloadButtonWrapper isEvent={true}>
                {role === "ADMIN" ? (<div style={{ marginRight: "6px" }} >
                  <HoverButton svgPath={AddCoachEventsIcon()} 
                    inActiveColor={"#DA6C74"}
                    backgroundColor={"rgba(254, 254, 254, 0.60)"}
                    backgroundColorActive={"#DA6C74"}
                    activeColor={"#DA6C74"}
                    fillOpacity={1} title={"Create Coach"} onClick={() => history.push("/company/events/create-coach")} />
                </div>):null}
                {role === "ADMIN" ? (<div style={{ marginRight: "6px" }} >
                  <HoverButton 
                    fillOpacity={1}
                    marginLeft="16px"
                    svgPath={AdminDownloadIcon(24,24)} 
                    activeColor={"#DA6C74"}
                    inActiveColor={"#DA6C74"}
                    backgroundColor={"rgba(254, 254, 254, 0.60)"}
                    backgroundColorActive={"#DA6C74"}
                    title={"Download On-Demand Events"} onClick={()=>downloadEnrolledList(true)} />
                </div>):null}

                <div className="create-events" style={{padding: "0px"}}>
                  {   selectedTabId !== 4 && (isWellnessAdmin ? (
                    <Dropdown>
                      <Dropdown.Toggle>
                        <HoverButton
                          width="24px"
                          height="24px"
                          marginLeft="16px"
                          svgPath={WellnessAddIconBranding()} 
                          activeColor={"#DA6C74"} 
                          fillOpacity={1}
                          inActiveColor={"#DA6C74"}
                          backgroundColor={"rgba(254, 254, 254, 0.60)"}
                          backgroundColorActive={"#DA6C74"}
                          title={"Create Events"} />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => history.push(`/company/events/create`)} >
                        Create Live Event
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => history.push({pathname :`/company/events/create` , state: isCelebrationEvent })} >
                        Create Celebration Event
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    <Dropdown>
                      <Dropdown.Toggle>
                        <HoverButton
                          width="24px"
                          height="24px"
                          marginLeft="16px"
                          svgPath={WellnessAddIconBranding()} 
                          activeColor={"#DA6C74"} 
                          fillOpacity={1}
                          inActiveColor={"#DA6C74"}
                          backgroundColor={"rgba(254, 254, 254, 0.60)"}
                          backgroundColorActive={"#DA6C74"}
                          title={"Create Events"} />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => history.push(`/company/events/create`)} >
                        Create Live Event
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => history.push({pathname :`/company/events/create-ondemand` , state:selectedTabId })} >
                        Create Engagement Event
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => history.push(`/company/events/create-lunch-learns`)}>
                        Create Lunch and Learns Event
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>))}
                </div>
                {(selectedTabId !== 3 &&  selectedTabId !== 4) ? <YearDropdownNew
                  refOutside={dropdownRef}
                  toggleMenu={toggleMenu}
                  background={"white"}
                  title={
                    selectedYearInfo && (
                      <div
                        className="title"
                        style={{
                          display: "flex",
                          justifyContent: yearList?.length > 1 ? "space-between" : "center",
                          width: "100%",
                          fontFamily: "Lato",
                          color: "#BDBDBD",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "20px",

                        }}
                      >
                        <div>{selectedYearInfo}</div>
                        {yearList?.length > 1 && (<div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "16px",
                          }}
                        >
                          <div style={{width:"16px",height:"16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            transform: menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
                          }}>{DropIcon("#DA6C74")}</div>
                        
                        </div>)}
                      </div>
                    )
                  }
                  data={yearList}
                  onSelect={updateDropdown}
                  style={{
                    background: "white",
                    lineHeight: "20px",
                    color: "rgba(0, 92, 135, 0.6)",
                    padding: "0px",
                    border: "1px solid #BDBDBD",
                    marginRight:"8px",
                    marginTop: "4px",
                    marginBottom: "4px"
                  }}
                />: null}
                
              </DownloadButtonWrapper>
            </TabContainerV1>

            {/* Completed Events Sub Tabs with Bottom Border */}
            {selectedTabId === 2 && (
              <div style={{ marginBottom: "20px" }}>
                <div style={{ 
                  display: "flex", 
                  marginBottom: "20px", 
                  
                  position: "relative" 
                }}>
                  <div 
                    style={{ 
                      padding: "12px 12px", 
                      cursor: "pointer", 
                      fontFamily: "'Lato', sans-serif",
                      fontSize: "16px",
                    
                      position: "relative",
                      transition: "all 0.3s ease"
                    }}
                    onClick={() => setCompletedSubTab("events")}
                  >
                    Events
                    {completedSubTab === "events" && (
                      <div style={{
                        position: "absolute",
                        bottom: "3px",
                        left: "5px",
                        width: "90%",
                        height: "2px",
                        backgroundColor: getColor,
                        borderRadius: "2px 2px 0 0"
                      }} />
                    )}
                  </div>
                  <div 
                    style={{ 
                      padding: "12px 12px", 
                      cursor: "pointer", 
                      fontFamily: "'Lato', sans-serif",
                      fontSize: "16px",
                    
                      position: "relative",
                      transition: "all 0.3s ease"
                    }}
                    onClick={() => setCompletedSubTab("themed")}
                  >
                    Celebration Events
                    {completedSubTab === "themed" && (
                      <div style={{
                        position: "absolute",
                        bottom: "3px",
                        left: "5px",
                        width: "90%",
                        height: "2px",
                        backgroundColor: getColor,
                        borderRadius: "2px 2px 0 0"
                      }} />
                    )}
                  </div>
                </div>
              </div>
            )}

            {selectedTabId === 1 && (
              <MemoizedOverview {...memoizedOverviewProps} />
            )}
            {selectedTabId === 2 && completedSubTab === "events" && (
              <CompletedEvent
                history={history}
                pastEvents={pastEvents}
                loadMoreEvents={(pageNumber) => loadMorePastEvents(pageNumber)}
                totalCount={totalCount}
                role={role}
                isAdmin={createEventPermission}
                fetchPastEvents={GetCompletedEvents}
                showLoadPast={showLoadPast}
              />
            )}
            {selectedTabId === 2 && completedSubTab === "themed" && (
              <ThemedEvents
                themedEvents={themedEvents}
                history={history}
                isAdmin={createEventPermission}
                showLoadPast={showLoadPast}
                loadMoreEvents={(pageNumber) => loadMoreThemedEvents(pageNumber)}
                totalCount={totalCount}
              />
            )}
            {selectedTabId === 3 && (
              <EventLibrary
                history={history}
                pastEvents={pastEvents}
                loadMoreEvents={(pageNumber) => loadMorePastEvents(pageNumber)}
                totalCount={totalCount}
                role={role}
                isAdmin={createEventPermission}
                fetchPastEvents={GetCompletedEvents}
                showLoadPast={showLoadPast}
                companyId={companyInfo?.id}
              />
            )}
            {selectedTabId === 4 && 
             (<CoachDirectory
               history={history}
             />)
            }
            {printCSV &&
              <CSVList
                Title={"List of All On-Demand Events"}
                removeCSVData={downloadEnrolledList}
                headers={CsvHeaders}
                data={printAction()}
              />
            }
          </DashboardLayout>
        </OverlayDashboard>
      </div>
    </Container>
  );
};

CompanyEvents.defaultProps = {
  companyInfo: { id: 1, name: "" },
};

CompanyEvents.propTypes = {
  networkError: PropTypes.string,
  companyInfo: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  history: PropTypes.object,
  selectedYearInfo: PropTypes.number,
  yearList: PropTypes.array,
  setSelectedYear: PropTypes.func,
  user: PropTypes.object,
  challengesData: PropTypes.array,
  t: PropTypes.func,
  selectedTabId: PropTypes.number,
  pastEvents: PropTypes.array,
  totalCount: PropTypes.number,
  userPermissions: PropTypes.array,
  brandingColor:PropTypes.string,
  allRoles: PropTypes.array,
};

const mapStateToProps = (state) => ({
  networkError: state.companyDashboard.networkError,
  selectedYearInfo: state.companyDashboard.selectedYearInfo,
  user: state.profileData.user,
  pastEvents: state.events.pastEvents,
  totalCount: state.events.totalCount,
  role: state.auth.role,
  userPermissions: state.profileData.userPermissions,
  brandingColor:state.wellnessDashboard.brandingColor,
  allRoles: state.profileData.allRoles,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedYear: (year) => dispatch(setSelectedYear(year)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyEvents);